export default {
  "notifications": {
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["te-a urmărit"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notificări"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Citit!"])}
  }
}